// extracted by mini-css-extract-plugin
export default {"root":"S8EYEo2d","root__vkcom":"hJvodaDt","root__active":"PLvcBQRW","badge":"DEsSsWVn"};